export const productTagFields = () => [
    {
        name: 'product_tag_name',
        type: 'text',
        label: 'Product Brand Name',
        required: true,
    },
    {
        name: 'empty_col_1',
        type: 'empty-column',
    },
    {
        name: 'empty_col_2',
        type: 'empty-column',
    },
   
    {
        name: 'description',
        type: 'textarea',
        colSpan: 6,
    },
];
